<template>
  <v-container fluid id="financial-house" :class="isMobile ? 'mobile' : 'pb-3'">
    <v-row class="text-center text-white" :class="{ 'pt-1': !isMobile }">
      <v-col v-if="isMobile">
        <div class="mb-4">
          <h2 role="heading" aria-level="2" class="text-h5 font-weight-bold">
            {{ $t('L_my_financial_house') }}
          </h2>
        </div>
        <HouseMainSVG :nav-type="1" @click="nav.goToMyFinancialHome()" />
        <a @click.prevent="show = !show">
          <v-icon v-if="show" class="font-size-48" :icon="mdiChevronDown" />
          <v-icon v-else class="font-size-48" :icon="mdiChevronUp" />
        </a>
      </v-col>
      <v-col v-else>
        <div class="mb-4">
          <h2 role="heading" aria-level="2" class="text-h4 font-weight-bold">
            {{ $t('L_my_financial_house') }}
          </h2>
        </div>
        <HouseMainSVG :nav-type="0" />
      </v-col>
    </v-row>
    <v-row v-if="show" class="text-center text-white">
      <v-col cols="12" :class="{ 'cursor-pointer': nav.hasActiveDebt() }" @click="nav.debtAction">
        <v-row>
          <v-col cols="4"
            ><HouseNavSvg :svg-type="3" :active="nav.hasActiveDebt()" svg-title="Debt Solutions"
          /></v-col>
          <v-col cols="8" class="cursor-pointer text-left font-weight-bold mt-1 pl-2">
            <h4 role="presentation" class="font-weight-medium active">
              {{ $t('L_debt_freedom') }}
            </h4>
            <h5 role="presentation" class="active">
              <span>{{ nav.hasActiveDebt() ? $t('L_active') : $t('L_learn_more') }}</span>
            </h5>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="show" class="text-center text-white">
      <v-col
        cols="12"
        :class="{ 'cursor-pointer': nav.hasInvestments() }"
        @click="nav.investmentsAction"
      >
        <v-row>
          <v-col cols="4"
            ><HouseNavSvg :svg-type="2" :active="nav.hasInvestments()" svg-title="Investments"
          /></v-col>
          <v-col cols="8" class="cursor-pointer text-left font-weight-bold mt-1 pl-2">
            <h4 role="presentation" class="font-weight-medium active">
              {{ $t('L_savings_investments') }}
            </h4>
            <h5 role="presentation" class="active">
              {{ nav.hasInvestments() ? $t('L_active') : $t('L_learn_more') }}
            </h5>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="show" class="text-center text-white">
      <v-col
        cols="12"
        class="last"
        :class="{ 'cursor-pointer': nav.hasTermLife() }"
        @click="nav.termLifeAction"
      >
        <v-row>
          <v-col cols="4"
            ><HouseNavSvg :svg-type="1" :active="nav.hasTermLife()" svg-title="Life Insurance"
          /></v-col>
          <v-col cols="8" class="cursor-pointer text-left font-weight-bold mt-1 pl-2">
            <h4 role="presentation" class="font-weight-medium active">{{ $t('L_term_life') }}</h4>
            <h5 role="presentation" class="active">
              {{ nav.hasTermLife() ? $t('L_active') : $t('L_learn_more') }}
            </h5>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HouseMainSVG from '@/components/HouseMainSVG/HouseMainSVG.vue';
import HouseNavSvg from '@/components/HouseNavSVG/HouseNavSVG.vue';
import { getNav } from '@/shared/navLogic';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

export default defineComponent({
  name: 'FinancialHouse',
  components: { HouseMainSVG, HouseNavSvg },
  data() {
    return {
      show: false,
      mdiChevronDown,
      mdiChevronUp,
      nav: getNav(),
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.display.mdAndDown;
    },
  },
  watch: {
    isMobile() {
      if (!this.isMobile) {
        this.show = true;
      }
    },
    $route() {
      if (this.isMobile) {
        this.show = false;
      }
    },
  },
  mounted() {
    if (!this.isMobile) {
      this.show = true;
    }
  },
});
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}

#financial-house {
  width: 100%;
  background-image: linear-gradient(to top, #012f60, #013b71);

  &.mobile {
    background: inherit;

    .body {
      margin: 25px auto;
      max-width: 75%;
    }
  }

  &:not(.mobile) {
    .body > .flex {
      max-width: 100%;
      flex-basis: 100%;
    }
  }

  .body {
    > .flex {
      margin: 0 auto;
    }

    .layout:not(.last):not(.wrap) {
      margin: 0 0 15px;
      padding: 0 0 15px;
      border-bottom: 2px solid #165390;
    }
  }

  .font-weight-medium {
    font-weight: 500 !important;
  }

  .inactive {
    opacity: 0.4;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .active-icon {
    position: absolute;
    left: 40px;
    color: #ffffff !important;
  }

  .theme--light.v-icon {
    color: #fff;
  }
}
</style>
